import "./topnav.scss";

export default function TopNav(props) {
  const { title, children } = props;
  return (
    <div className="w-full px-6 py-3 h-16 flex items-center justify-between top-nav gap-1">
      <div className="flex flex-row items-center gap-2">
        <p className="font-medium text-nowrap">{title}</p>
      </div>
      {children}

      {/* <div className="flex flex-row items-center gap-2">
        <p>We</p>
        <SvgHeart width="18" className="fill-red-500" />
        <p className="">{user!.accountName!}</p>
      </div> */}
    </div>
  );
}
